jQuery(function () {
    if( jQuery('[data-master]').length ) {
        let identifier_master = 'master',
            identifier_slave = 'slave',
            identifier_state = 'state',
            elements_masters = jQuery('[data-' + identifier_master + ']'),
            elements_slaves = jQuery('[data-' + identifier_slave + ']');

        elements_masters.on('click', function () {
            let identifier = jQuery(this).data(identifier_master);

            jQuery(this).siblings('[data-' + identifier_state + ']').attr('data-' + identifier_state, 0);
            jQuery('[data-' + identifier_slave + '="' + identifier + '"]').attr('data-' + identifier_state, 1).siblings('[data-' + identifier_state + ']').attr('data-' + identifier_state, 0);
            
            jQuery(this).attr('data-' + identifier_state, 1);
        });

        // check for hash match in url
        if( window.location.hash.length ) {
            let hash = window.location.hash.substring(1),
                element_master = jQuery(('[data-' + identifier_master + '=' + hash + ']'));

            if( element_master.length > 0 ) {
                // console.log('pew');
                element_master.trigger('click');
                if( element_master.parent('.role_selection') ) {
                    let master_group = element_master.closest('[data-' + identifier_slave + ']').attr('data-' + identifier_slave);
                    let element_master_group = jQuery(('[data-' + identifier_master + '=' + master_group + ']'));
                    element_master_group.trigger('click');
                }

                // scroll to position
                jQuery('html, body').animate({
                    scrollTop: jQuery("#roles").offset().top
                }, 200);
            }
        }

        // console.log({hash});
        // console.log(element_master.length);
        
    }
});